var WIX_IMAGES_HOST = 'static.wixstatic.com';
var DEFAULT_SIZE = 1000;
var DEFAULT_QUALITY = 80;
var ImageService = /** @class */ (function () {
    function ImageService() {
        var _this = this;
        this.resize = function (w, h, rw, rh) {
            if (rw > w && rh > h) {
                return {
                    width: w,
                    height: h,
                };
            }
            return {
                width: rw,
                height: rh,
            };
        };
        this.isImageObject = function (parameter) { return !!parameter && !!parameter.file_name; };
        this.getImageUrl = function (properties) {
            var image = properties.image, _a = properties.rw, rw = _a === void 0 ? DEFAULT_SIZE : _a, _b = properties.rh, rh = _b === void 0 ? DEFAULT_SIZE : _b, _c = properties.quality, quality = _c === void 0 ? DEFAULT_QUALITY : _c;
            if (typeof image === 'string') {
                return image;
            }
            if (_this.isImageObject(image)) {
                var fileName = image.file_name, w = image.width, h = image.height;
                var _d = _this.resize(w, h, rw, rh), width = _d.width, height = _d.height;
                return "https://" + WIX_IMAGES_HOST + "/media/" + fileName + "/v1/fit/w_" + width + ",h_" + height + ",al_c,q_" + quality + "/file.jpg";
            }
            return '';
        };
    }
    return ImageService;
}());
export { ImageService };
//# sourceMappingURL=image.js.map